import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NewellMemory {
  private DATA: any;

  constructor() {
    this.DATA = {};
  }

  public set(key, value) {
    this.DATA[key] = value;
    return true;
  }

  public get(key) {
    return this.DATA[key] ? this.DATA[key] : null;
  }

  public remove(key) {
    if (this.DATA.hasOwnProperty(key)) {
      delete this.DATA[key];
      return true;
    }
    return false;
  }

  public clear() {
    this.DATA = {};
  }

  public snapshot() {
    return Object.keys(this.DATA).length ? this.DATA : null;
  }
}
